module.exports = __webpack_public_path__ + "static/media/3.70f0ddad.svg";